export default __webpack_public_path__ + "static/media/productBuoy.2c9baa51.svg";